import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

const SEARCH_LEFT_AREA_PX = 12 + 20 + 15
const MOBILE_ICON_PLUS_GAP_PX = 20 + 12
const CLEAR_BUTTON_AREA_PX = 12 + 12 + 4

export const containerStyle = {
    px: 0,
    py: {base: pxToRem(10), md: 0},
    position: {base: 'relative', md: 'static'}
}

export const searchInputStyle = {
    variant: 'filled',
    size: 'sm',
    color: 'white',
    bgColor: 'transparent',
    borderWidth: pxToRem(1),
    borderColor: 'white',
    width: {base: '100%', sm: '100%', md: pxToRem(153), lg: pxToRem(153)},
    height: {base: pxToRem(32), sm: pxToRem(32), md: pxToRem(30)},
    // iOS zooms inputs with font-size < 16px. Keep 16px on mobile to prevent zoom.
    fontSize: {base: pxToRem(16), sm: pxToRem(16), md: pxToRem(16)},
    padding: {
        base: `${pxToRem(6)} ${pxToRem(CLEAR_BUTTON_AREA_PX)} ${pxToRem(6)} ${pxToRem(
            MOBILE_ICON_PLUS_GAP_PX
        )}`,
        sm: `${pxToRem(6)} ${pxToRem(CLEAR_BUTTON_AREA_PX)} ${pxToRem(6)} ${pxToRem(
            MOBILE_ICON_PLUS_GAP_PX
        )}`,
        md: `${pxToRem(6)} ${pxToRem(CLEAR_BUTTON_AREA_PX)} ${pxToRem(6)} ${pxToRem(
            SEARCH_LEFT_AREA_PX
        )}`
    },
    letterSpacing: pxToRem(1),
    fontWeight: '500',
    borderRadius: '0',
    textAlign: 'left',
    _placeholder: {color: 'inherit'},
    _focus: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderColor: 'white',
        outline: 'none'
    },
    _focusVisible: {boxShadow: 'none', outline: 'none'},
    _hover: {backgroundColor: 'transparent', _focus: {backgroundColor: 'transparent'}},
    '::-webkit-search-cancel-button': {WebkitAppearance: 'none'},
    '::-ms-clear': {display: 'none'}
}

export const inputRightElementStyle = {
    right: 0,
    width: {base: pxToRem(28), sm: pxToRem(28), md: pxToRem(28), lg: pxToRem(28)},
    height: '100%',
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: {base: pxToRem(4), sm: pxToRem(4), md: pxToRem(4), lg: pxToRem(4)},
    pointerEvents: 'none'
}

export const clearButtonStyle = {
    color: 'white',
    fontSize: {base: pxToRem(14), sm: pxToRem(14), md: pxToRem(14), lg: pxToRem(14)},
    fontWeight: '500',
    letterSpacing: pxToRem(1),
    pointerEvents: 'auto',
    height: pxToRem(20),
    width: pxToRem(20),
    minWidth: pxToRem(20),
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    flexShrink: 0,
    _hover: {backgroundColor: 'transparent', opacity: 0.85},
    _active: {backgroundColor: 'transparent', opacity: 0.7}
}

export const inputLeftElementStyle = {
    pointerEvents: 'none',
    left: 0,
    width: {
        base: pxToRem(MOBILE_ICON_PLUS_GAP_PX),
        sm: pxToRem(MOBILE_ICON_PLUS_GAP_PX),
        md: pxToRem(SEARCH_LEFT_AREA_PX),
        lg: pxToRem(SEARCH_LEFT_AREA_PX)
    },
    top: '50%',
    transform: 'translateY(-50%)',
    display: {base: 'flex', md: 'flex'},
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: {base: pxToRem(6), sm: pxToRem(6), md: pxToRem(12), lg: pxToRem(12)},
    paddingRight: {base: pxToRem(12), sm: pxToRem(12), md: pxToRem(15), lg: pxToRem(15)}
}

export const popoverDesktopContentStyle = {
    borderRadius: '0',
    border: '2px solid black',
    boxShadow: 'none',
    background: 'white',
    p: 0,
    width: {base: '100%', md: pxToRem(395)},
    maxW: pxToRem(395),
    boxSizing: 'border-box',
    fontFamily: fonts.primary,
    display: {base: 'none', md: 'block'},
    '& [data-popper-arrow], & .chakra-popover__arrow-positioner': {
        left: `-${pxToRem(60)} !important`
    }
}

export const popoverArrowStyle = {
    bg: 'white',
    boxSize: pxToRem(20),
    marginLeft: pxToRem(8)
}

export const wrapperBoxStyle = {
    maxHeight: pxToRem(450),
    overflowY: 'auto',
    overflowX: 'hidden',
    px: pxToRem(15)
}

export const mobileDropdownStaticStyle = {
    position: 'absolute',
    left: '0',
    right: '0',
    top: pxToRem(52),
    width: '100%',
    background: 'white',
    border: '2px solid black',
    borderTop: 'none',
    zIndex: 99,
    borderRadius: '0',
    overflow: 'visible',
    display: {base: 'block', md: 'none'}
}

export const mobileDropdownArrowStaticStyle = {
    position: 'absolute',
    top: pxToRem(-8),
    left: pxToRem(16),
    width: '0',
    height: '0',
    borderLeft: `${pxToRem(8)} solid transparent`,
    borderRight: `${pxToRem(8)} solid transparent`,
    borderBottom: `${pxToRem(8)} solid white`,
    zIndex: 1
}

export const mobileDropdownBoxStyle = {
    px: pxToRem(15),
    py: pxToRem(12),
    overflowY: 'auto',
    maxH: pxToRem(440)
}

export const suggestionsHeaderStyle = {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: pxToRem(14),
    color: 'black',
    marginTop: pxToRem(24),
    marginBottom: pxToRem(8),
    fontFamily: fonts.primary
}

export const phraseLinkStyle = {
    width: '100%',
    py: pxToRem(8),
    fontSize: pxToRem(13),
    color: 'cav_faq_anchor_red',
    textDecoration: 'none',
    textTransform: 'capitalize',
    cursor: 'pointer',
    fontFamily: fonts.secondary,
    _hover: {textDecoration: 'none'}
}

export const featuredHeaderStyle = {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: pxToRem(12),
    marginTop: pxToRem(18),
    marginBottom: pxToRem(16),
    letterSpacing: pxToRem(3),
    color: 'cav_night_rider',
    fontFamily: fonts.secondary
}

export const productsRowStyle = {
    display: {base: 'flex', md: 'grid'},
    flexDirection: {base: 'column', md: undefined},
    gridTemplateColumns: {md: 'repeat(2, 1fr)'},
    gap: pxToRem(16),
    width: {base: '100%', md: '65%'},
    boxSizing: 'border-box',
    fontFamily: fonts.secondary
}

export const productCardStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    background: 'transparent',
    borderWidth: {base: pxToRem(1), md: 0},
    borderStyle: {base: 'solid', md: 'none'},
    borderColor: {base: 'cav_border_light', md: 'transparent'},
    borderBottom: {base: 'none', md: undefined},
    mb: {base: pxToRem(16), md: 0},
    p: {base: pxToRem(8), md: 0},
    flexDirection: {base: 'row', md: 'column'},
    textAlign: {base: 'left', md: 'center'},
    textDecoration: 'none',
    _hover: {textDecoration: 'none'}
}

export const productImageStyle = {
    flexShrink: 0,
    objectFit: 'cover',
    mr: {base: pxToRem(12), md: 0},
    mb: {base: 0, md: pxToRem(8)},
    fontFamily: fonts.secondary,
    fontSize: pxToRem(15),
    width: pxToRem(111),
    height: pxToRem(180)
}

export const productNameStyle = {
    fontSize: pxToRem(13),
    lineHeight: 1.2,
    mb: {base: pxToRem(4), md: pxToRem(4)},
    color: 'black',
    fontFamily: fonts.secondary,
    _hover: {color: 'red.cvs'}
}

export const productPriceStyle = {
    fontWeight: 'bold',
    fontSize: pxToRem(13),
    color: 'black'
}

export const productCardMobileStyle = {
    display: 'flex',
    width: '100%',
    textDecoration: 'none',
    mb: pxToRem(2),
    _hover: {textDecoration: 'none'}
}

export const productImageMobile = {
    flexShrink: 0,
    objectFit: 'cover',
    fontFamily: fonts.secondary,
    fontSize: pxToRem(15),
    width: pxToRem(111),
    height: pxToRem(180)
}
